// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"CopyNotification_mobileWidth__RTqYY"};